import React, { useState } from "react";

import "../../../css/NuestraCiudad/telefonos-utiles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const TelefonosUtiles = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Botón flotante abajo a la izquierda */}
      <button
        className="telefonos-float-btn"
        onClick={() => setOpen(true)}
        aria-label="Abrir teléfonos útiles"
      >
        <FontAwesomeIcon icon={faPhone}/>
        <span>Teléfonos útiles</span>
      </button>
      {/* Offcanvas superpuesto */}
      {open && (
        <div className="telefonos-offcanvas-bg" onClick={() => setOpen(false)}>
          <aside
            className="telefonos-offcanvas"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="telefonos-offcanvas-header">
              <h5>GUÍA DE TELÉFONOS</h5>
              <button
                className="telefonos-close-btn"
                onClick={() => setOpen(false)}
                aria-label="Cerrar"
              >
                ×
              </button>
            </div>
            <div className="telefonos-offcanvas-body">
              <ul className="telefonos-list">
                <li>
                  <b>Bomberos:</b> 100
                </li>
                <li>
                  <b>Policía:</b> 101
                </li>
                <li>
                  <b>Hospital:</b> 03532 428928
                </li>
                <li>
                  <b>Línea Central:</b> 03532 410045
                </li>
                <li>
                  <b>Atención al vecino:</b> 03532436447
                </li>
                <li>
                  <b>Registro Civil:</b> 03532 410142
                </li>
                <li>
                  <b>Corralón Municipal:</b> 03532 410509
                </li>
                <li>
                  <b>Oficina de Empleo</b>
                  <br />
                  Fijo: 03532 410046
                  <br />
                  Celular: 3532447906
                </li>
                <li>
                  <b>Tránsito y Seguridad Ciudadana:</b>
                  <br />
                  Fijo: 03532 410100
                  <br />
                  Celular: 03532447893
                </li>
                <li>
                  <b>Dir. De Inspección, Brom., y Ambiente</b>
                  <br />
                  Fijo: 03532 410289 Int. 35
                </li>
                <li>
                  <b>Centros de Salud:</b>
                  <br />
                  N° 1: “José Accosatto”: 03532 411195
                  <br />
                  N° 2: “Medalla Milagrosa”: 03532 411510
                  <br />
                  N° 3: “San Cayetano”: 03532 413528
                </li>
                <li>
                  <b>Dir. de Desarrollo Cultural:</b> 03532 412272
                </li>
                <li>
                  <b>Sec. Obras Públicas:</b>
                  <br />
                  Fijo: 03532 410289
                  <br />
                  Fijo: 03532 410045 Int. 31
                </li>
                <li>
                  <b>Punto Mujer:</b> 3532419382
                </li>
                <li>
                  <b>Centro Asistencial Oliva. Adicciones:</b> 03532441083
                </li>
                <li>
                  <b>Desarrollo Social:</b> 03532447891
                </li>
              </ul>
            </div>
          </aside>
        </div>
      )}
    </>
  );
};

export default TelefonosUtiles;
